module.exports = __webpack_public_path__ + "assets/img/phone_title.faaf16e1.png";